<template>
    <div>
        <tsoft-table
            :api="tableApiUrl"
            :items.sync="items"
            :isNeedSearch="true"
            :isNeedCreate="isNeedCreate"
            :additionalGetParameter="additionalGetParameter"
            @show="showItem"
            @edit="createOrEditItemModal"
            @delete="deleteItem"
            :customAddButtonName="'Добавить'"
        />

        <tsoft-create-truck
            :isSideBarOpenDriver.sync='isSideBarOpenDriver'
            :editIndex.sync="editIndex"
            :editedItemExt.sync="editedItem"
            @create='setCreatedDriver'
            @update='setUpdatedDriver'
            @closeSidePanel='setClosedSidePanelDriver'
        />

        <b-sidebar
            v-if="isSidebarOpenDetail"
            v-model="isSidebarOpenDetail"
            id="sidebar-right"
            right
            backdrop
            shadow
            width="109em"
            backdrop-variant="dark"
            no-close-on-backdrop
        >
            <template #title>
                <div class="title-sidebar">
                    <strong class="ml-4">Детальная информация</strong>
                </div>
            </template>
            <div class="d-block">
                <div class="row">
                    <div class="col-md-2">
                        <ul class="parent_item_block d-none d-sm-block nav fa-ul">
                            <li class="parent_item nav-item">
                                <a class="nav-link active" data-toggle="tab" href="#company-details"><span class="fa-li"><i class="fas fa-chevron-right"></i></span> Детали</a>
                            </li>
                            <li class="parent_item nav-item">
                                <a
                                class="nav-link"
                                data-toggle="tab"
                                href="#company-change-history"
                                @click="changeLoad = !changeLoad"
                                >
                                <span class="fa-li"><i class="fas fa-chevron-right"></i></span>
                                    История
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div class="col-md-10">
                        <div class="tab-content">
                            <div class="tab-pane fade show active" id="company-details">
                                <tsoft-truck-details
                                    :itemId="detailedItem.id"
                                />
                            </div>
                            <div class="tab-pane fade" id="company-change-history">
                                <h5 class="mb-4">История изменений водителя <span class="text-secondary">{{detailedItem.name}}</span> (#{{detailedItem.id}})</h5>
                                <tsoft-change-history
                                    :changeHistoryId.sync="detailedItem.id"
                                    :changeModel.sync="model_name"
                                    :changeLoad.sync="changeLoad"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-sidebar>
    </div>
</template>

<script>
    import { API_TRUCKS } from "../constants"
    import tsoftCreateTruck from "../components/trucks/CreatedOrEditedTruck.vue"
    import tsoftChangeHistory from '../components/logs/ChangeHistory.vue'
    import tsoftTruckDetails from '../components/trucks/TruckDetails.vue'

    import {
        defaultDataItems,
        actionShowItem,
        actionCreateOrUpdateItem,
        actionDeleteItem,
    } from '../mixins'
    import { mixinDocuments } from '../mixins/mixinDocuments'

    const initialEditedItem = () => ({
        'id': '',
        'creator_user_id': '',
        'brand': '',
        'year': '',
        'number': '',
        'ctc_number': '',
        'ctc_file_face_id': '',
        'ctc_file_back_id': '',
        'ptc_number': '',
        'ptc_file_face_id': '',
        'ptc_file_back_id': '',
        'owner': true,
        'rent_number': '',
        'rent_file_id': '',
        'reference_truck_type_id': '',
        'reference_truck_body_type_id': '',
        'type_of_loading': '',
        'dimensions_length': '',
        'dimensions_width': '',
        'dimensions_height': '',
        'dimensions_volume': '',
        'carrying': '',
        'checked_id': 443,
        'creator': {},
        'companies': [],
        'truck_type': {},
        'truck_body_type': {},
        'checked': {},
        'ctc_file_face': null,
        'ctc_file_back': null,
        'ptc_file_face': null,
        'ptc_file_back': null,
        'rent_file': null,
        'new_ctc_file_face': null,
        'new_ctc_file_back': null,
        'new_ptc_file_face': null,
        'new_ptc_file_back': null,
        'new_rent_file': null,
    })

    export default {
        props: {
            isNeedCreate: { type: Boolean, required: false, default: true },    // If table needs create new element button
            additionalGetParameter: { type: String, required: false, default: '' }, // If we want to add something, for example, &company_id=10
            // typeOfTableFilter: { type: String, required: false, default: '' },      // Type of filter for output: orders, services
        },
        components: {
            "tsoft-create-truck": tsoftCreateTruck,
            'tsoft-change-history': tsoftChangeHistory,
            'tsoft-truck-details': tsoftTruckDetails,
        },
        mixins: [
            defaultDataItems,
            actionShowItem,
            actionCreateOrUpdateItem,
            actionDeleteItem,
            mixinDocuments
        ],
          data() {
            return {
                model_name: ['App\\Models\\Truck'],
                changeLoad: false,
                isSideBarOpenDriver: false,
                isSideBarOpenPaymentDetails: false,
                tableApiUrl: API_TRUCKS,
            }
        },
        mounted() {
            this.editedItem = initialEditedItem()
        },
        methods: {
            onCloseSidePanelLoadingDocument(value) {
                if(value == true){
                    this.checkedLoadDocument = false
                }
            },
            // calls from mixin on show sidebar company
            onOpenCompanyModalCallback() {
                this.isSideBarOpenDriver = true
            },
            setCreatedDriver(data) {
                this.items.data.unshift(data)
                this.editedItem = initialEditedItem()
            },
            setUpdatedDriver(data) {
                Object.assign(this.items.data[this.editIndex], data)
                this.editedItem = initialEditedItem()
                this.editIndex = -1
            },
            setClosedSidePanelDriver(){
                this.editedItem = initialEditedItem()
                this.editIndex = -1
            },
            setCountryCompany(value) {
                this.editedItem = initialEditedItem()
            },
        }
    }
</script>
